import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from 'models/field.interface';
import { UtilityService } from 'services';

@Component({
  templateUrl: './select.component.html'
})
export class SelectComponent {
  field: FieldConfig;
  group: FormGroup;
  constructor(private util: UtilityService) { }
  isRequired() {
    return this.util.isRequired(this.group.get(this.field.name));
  }
  getValidationMessage(val) {
    return 'Please Select an Option.';
  }
}
